import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="container mx-auto flex min-h-[60vh] max-w-4xl items-center justify-center px-4">
      <div className="text-center">
        <h1 className="mb-4 text-6xl font-bold text-foreground">404</h1>
        <h2 className="mb-4 text-2xl font-semibold text-foreground">Sidan hittades inte</h2>
        <p className="mb-8 text-muted-foreground">
          Tyvärr kunde vi inte hitta sidan du letar efter.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
        >
          <Home className="h-4 w-4" />
          Tillbaka till startsidan
        </Link>
      </div>
    </div>
  );
}
